const colors = {
  primary: '#ffc706', // '#5ed46a',
  // primary: '#67e774',
  secondary: '#7d5dec',
  third: '#adff00',
  success: '#52c41a',
  warn: '#faad14',
  font_dark: '#333232',
  font_light: '#F5F5F5',
  font_menu: '#DCDCDC',
  background_dark: '#333232',
  background_light: '#F5F5F5',
  background_header: 'white',
  shadow: 'rgba(0, 0, 0, .1)',
  input: '#BCBCBC',
  table_border: '#eaeaea',
};

export default colors;
